import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { Button, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import config from "../../config";
import canawhoLogoImgNotFound from "../../assets/img/logo-black-img-not-found.png";
import ImageUpload from "../image-upload.component";
import VideoUpload from "../video-upload.component";

const BACKEND_URL = config.backend.host;

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 120,
  },
  textField: {
    marginLeft: 10,
    marginRight: 10,
    width: "250px",
  },
  dense: {
    marginTop: 16,
  },
  menu: {
    width: 200,
  },
  button: {
    margin: theme.spacing(),
  },
  leftIcon: {
    marginRight: theme.spacing(),
    fontSize: 20,
  },
});

class MediaAdd extends Component {
  state = {
    title: "",
    content: "",
    date: "",
    image: "",
    video: "",
    source: "",
    page_title: "Add",
    isEdit: false,
  };
  constructor(props) {
    super(props);
    this.btnSaveOnClick = this.btnSaveOnClick.bind(this);
    this.btnCancelOnClick = this.btnCancelOnClick.bind(this);
    //TODO: use the json from the previously call, if possible
    if (props.match.params.id) {
      //TODO: remove magic string
      axios
        .get(BACKEND_URL + `/media/${props.match.params.id}`)
        .then((response) => this.loadData(response.data))
        .catch((err) => {
          // console.log(err)
        });
    }
  }

  loadData(media) {
    this.setState({
      _id: media._id,
      title: media.title,
      content: media.content,
      date: media.date,
      image: media.image,
      video: media.video,
      source: media.source,
      page_title: "Edit",
      isEdit: true,
    });
    this.getBrands();
  }

  getBrands() {
    axios
      .get(BACKEND_URL + "/brand/")
      .then((response) => this.setState({ brands: response.data }))
      .catch((err) => alert(err));
  }

  btnCancelOnClick(e) {
    e.preventDefault();
    this.props.history.goBack();
  }

  btnSaveOnClick(e) {
    e.preventDefault();
    const obj = {
      title: this.state.title,
      content: this.state.content,
      date: this.state.date,
      image: this.state.image,
      video: this.state.video,
      source: this.state.source,
    };
    //console.log("SENDING...");
    //TODO: show message DONE with snackbar
    if (this.state.isEdit) {
      axios
        .put(BACKEND_URL + `/media/${this.state._id}`, obj)
        .then((res) => this.saveSuccess(res))
        .catch((e) =>
          alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    } else {
      axios
        .post(BACKEND_URL + "/media", obj)
        .then((res) => this.saveSuccess(res))
        .catch((e) =>
          alert(`Error: ${e} | Response: ${e.response.data.message}`)
        );
    }
  }
  saveSuccess(response) {
    //TODO: Set a snack bar with Redux to show messages after saving
    alert("Saved");
    this.props.history.goBack();
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  cbSetImageNewLink(link) {
    this.setState({ image: link });
    alert("Image uploaded successfully");
  }

  cbSetVideoNewLink(link) {
    this.setState({ video: link });
    alert("Video uploaded successfully");
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Typography variant="h4" gutterBottom>
          {this.state.page_title} Media
        </Typography>
        <Grid container>
          <form
            className={classes.container}
            autoComplete="off"
            onSubmit={this.btnSaveOnClick}
          >
            <Grid item xs={12}>
              <TextField
                id="tfTitle"
                label="Title"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.title}
                onChange={this.handleChange("title")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                label="Content"
                multiline
                rows="9"
                value={this.state.content}
                className={classes.textField}
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                onChange={this.handleChange("content")}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="tfDate"
                label="Date"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.date}
                onChange={this.handleChange("date")}
              />
            </Grid>
            <Grid
              container
              spacing={16}
              //justify='center'
              alignItems="center"
              direction="column"
            >
              <Grid item>
                <img
                  alt=""
                  src={
                    this.state.image ? this.state.image : canawhoLogoImgNotFound
                  }
                  width="200px"
                />
              </Grid>
              <Grid item>
                <ImageUpload cbFunction={this.cbSetImageNewLink.bind(this)} />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <VideoUpload cbFunction={this.cbSetVideoNewLink.bind(this)} />
              <TextField
                id="tfVideo"
                label="Video"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.video}
                onChange={this.handleChange("video")}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="tfSource"
                label="Source"
                margin="normal"
                variant="outlined"
                style={{ width: "98%", marginLeft: 10 }}
                value={this.state.source}
                onChange={this.handleChange("source")}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                name="btnSave"
                type="submit"
              >
                <SaveIcon className={classes.leftIcon} />
                Save
              </Button>
              <Button
                variant="contained"
                size="medium"
                className={classes.button}
                onClick={this.btnCancelOnClick}
              >
                <CancelIcon className={classes.leftIcon} />
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </div>
    );
  }
}

MediaAdd.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaAdd);
